import BGPH1 from '../../assets/images/backgrounds/bnrimage.jpeg'
import ABOUTIMG from '../../assets/images/resources/about.png'
import BGVImg1 from "../../assets/images/backgrounds/video-bg-1-1.jpg";
import { Link } from 'react-router-dom'
import React, { useRef, useState, useEffect } from "react";

import {
    MDBTabsContent,
    MDBTabsPane
  } from 'mdb-react-ui-kit';
import Footer from '../Footer/Main';
import Navbar from '../Navbar/Main';

const Mpchallenge = () => {
	 const [ytShow, setytShow] = useState(false);
  return (
    <>
<Navbar/>
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>
      <section className="page-header">
        <div className="page-header__bg"   ></div>

        <div className="container">
                <ul className="thm-breadcrumb list-unstyled">
                    <li><Link to="/">Home</Link></li>
                    <li><span>Monetary Policy Challenge</span></li>
                </ul>
            </div>
      </section>
      <section className="service-five pt-50 pb-50">
      <div className="container">
      <div className="row row-gutter-y-0 service-four__inner">
            <div className="col-lg-6">
              <div className="about-four__content">
                <div className="block-title text-left">
                  <p className="block-title__tagline">About the Monetary Policy Challenge</p>
                </div>
                {/* <div className="about-four__box">
                  <div className="about-four__box__icon">
                    <i className="icon-bank"></i>
                  </div>
                  <div className="about-four__box__content">
                    <h3 className="about-four__box__title">
                      Toward a World Class Central Bank.
                    </h3>
                  </div>
                </div> */}
                <p className="about-four__text">
                The Monetary Policy Challenge (MPC), an initiative by the National Bank of Rwanda (NBR), 
				is Rwanda's premier platform for university students to engage in high-level economic and monetary policy discussions. 
				Since its launch in 2019, the competition has attracted over 1,500 participants from universities across the country, 
				serving as a vital talent pipeline for Rwanda's financial sector. 
				Many MPC alumni have gone on to build successful careers at the NBR, Ministry of Finance & Economic Planning, 
				Ministry of Trade & Industry, and leading private sector institutions. 
                </p>
              <p className="about-four__text">
                <h6><b>Alumni Spotlights</b></h6>
              
              From ambition to achievement: 
              Celebrating the inspiring journeys of our MPC alumni as they pave diverse paths to success, impact, and growth.
              <a href="https://www.ajol.info/index.php/BNRER/article/view/271369" target="_blank"> Browse the different works of NBR alumni</a>
              </p>
               <p className="about-four__text">
                <h6><b>Opportunities Corner</b></h6>
              
              Unlock your potential with exclusive career opportunities, 
              internships at NBR designed to fuel your professional journey and growth.
              <a href="https://e-recruitment.bnr.rw" target="_blank"> Discover career opportunities at NBR</a>
              </p>
               <p className="about-four__text">
                <h6><b>Engagement Features</b></h6>
              
              Highlights and recaps of Monetary Policy Challenge activities showcasing collaboration, 
              learning, and real-world policy simulation experiences.
              <a href="https://youtu.be/lhl7dmH2dvg?si=7TiowB814l97kew9" target="_blank"> Hear from MPC alumni</a>
              </p>
{/*              
                <div className="about-four__btns">
                  <Link to="/about" className="thm-btn thm-btn--dark-hover">
                    Discover More
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="col-lg-6">
                     <iframe
                        width="550"
                        height="310"
                        src="https://www.youtube.com/embed/ATq83zeuMZg"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                        allowfullscreen
                      ></iframe>
            </div>
          </div>
          </div>


        </section>

        <section className="contact-info-one">
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-sm-12">
                        <div className="contact-info-one__item">
                            <div className="contact-info-one__icon">
                                <i className="icon-telephone"></i>
                            </div>
                            <div className="contact-info-one__content">
                                <p className="contact-info-one__text">For inquiries:</p>
                                <a className="contact-info-one__link" href="tel:+ (250) 788199000 ">+ (250) 788199000 </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <div className="contact-info-one__item">
                            <div className="contact-info-one__icon">
                                <i className="icon-email"></i>
                            </div>
                            <div className="contact-info-one__content">
                                <p className="contact-info-one__text">Send us an email on:</p>
                                <a className="contact-info-one__link" href="mailto:info@bnr.rw">info@bnr.rw</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <div className="contact-info-one__item">
                            <div className="contact-info-one__icon">
                                <i className="icon-pin"></i>
                            </div>
                            <div className="contact-info-one__content">
                                <p className="contact-info-one__text">HQ Address:</p>
                                <a className="contact-info-one__link" href="#"> KN 6 AV 4, Kigali Rwanda</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		
{/* 

        <div className="google-map__default">
            <iframe title="template google map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1020806.7305464278!2d29.319977754475655!3d-1.9421909721377053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19c29654e73840e3%3A0x7490b026cbcca103!2sRwanda!5e0!3m2!1sen!2sin!4v1540289964660" className="map__default" allowFullscreen></iframe>
        </div> */}

<Footer/>
    </>
  )
}

export default Mpchallenge